import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import './spinner.scss';

const styles = bemGenerator('pj-ui-spinner');

const Spinner = props => {
  const { isActive, position, size } = props;

  const spinnerSize = {
    height: size,
    width: size,
    borderWidth: size < 18 ? 2 : size > 36 ? 6 : 4, // eslint-disable-line
  };

  const spinnerPosition = {
    [position]: true,
  };

  return isActive ? (
    <span
      style={spinnerSize}
      className={styles.block.withModifier(spinnerPosition)}
    />
  ) : null;
};

const { bool, oneOf, number } = PropTypes;
Spinner.propTypes = {
  isActive: bool,
  position: oneOf(['left', 'right', 'center', 'none']),
  size: number,
};

Spinner.defaultProps = {
  isActive: false,
  position: 'center',
  size: 24,
};

export default Spinner;
